import styled from 'styled-components'
import { themeMedia, themeStyles } from '../../../styles/theme'

export const DepositPixPingContainer = styled.div`
  padding: 1rem 1.5rem 2rem 1.5rem;
  margin-top: 1rem;
  ${themeMedia.tablet`
        ${({ isDepositFlow }) =>
          isDepositFlow
            ? 'padding: 0 1.5rem 2rem 1.5rem;'
            : 'padding: 3rem 1.5rem 2rem 1.5rem;'}
        ${({ isDepositFlow }) =>
          isDepositFlow ? 'margin-top: 0.6rem;' : 'margin-top: 1.5rem;'}
    `};
`

export const DepositPixPingContent = styled.div``

export const DepositPixPingTitle = styled.div`
  gap: 10px;
`

export const DepositPixPingBody = styled.div`
  margin-top: 2rem;
`

export const ConfirmPixStepBody = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  height: calc(100svh - 260px);
  justify-content: space-between;

  @media (min-width: 385px) {
    height: calc(100svh - 240px);
  }

  ${themeMedia.tablet`
    height: calc(100svh - 335px);
  `}
`

export const ArrowBackPixPingContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100px;
  cursor: pointer;
  gap: 15px;
  margin-bottom: 1.7rem;
  margin-left: 0rem;
`

export const StyledInformationAlert = styled.div`
  display: flex;
  font-size: 14px;
  padding: 10px 16px 10px 16px;
  border: 2px solid ${themeStyles.colors.lightGreys[1].main};
  border-radius: 6px;
  gap: 11px;
  margin-bottom: 1rem;
`